export default "__VITE_ASSET__MnGZDguu__"